document.addEventListener("DOMContentLoaded", function () {
  const gate = document.getElementById("login-gate");

  if (!gate) return;

  // Show gate after 5 seconds for logged-out users
  setTimeout(function () {
    gate.style.display = "block";
    gate.setAttribute("aria-hidden", "false");

    // Prevent scrolling
    document.body.style.overflow = "hidden";
  }, 5000);
});
